import { render, staticRenderFns } from "./ProfilePostsPage.vue?vue&type=template&id=9ddbc3d0&scoped=true&"
import script from "./ProfilePostsPage.vue?vue&type=script&lang=js&"
export * from "./ProfilePostsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePostsPage.vue?vue&type=style&index=0&id=9ddbc3d0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddbc3d0",
  null
  
)

export default component.exports